import axios from 'axios';
import { acquireAppAccessToken } from "./auth/authService"

export const appAxiosInstance = axios.create({
    baseURL: '/'
});


appAxiosInstance.interceptors.request.use(async (config) => {
    const token = await acquireAppAccessToken();    
    config.headers.Authorization = `Bearer ${token}`;

    const impersonationUser = localStorage.getItem("impersonate");

    if (impersonationUser) {
        config.headers["x-impersonate-user"] = impersonationUser;
    }

    return config;
});


